import { useEffect, useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { PlusCircle } from "@phosphor-icons/react";

const nowTime = () => new Date().toTimeString().slice(0, 5);

export default function DeliveryForm({ warehouse, disabled, onAdd }) {
  const [carrier, setCarrier] = useState(warehouse.carriers[0]);
  const [packages, setPackages] = useState("");
  const [time, setTime] = useState(nowTime());
  const [notes, setNotes] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setCarrier(warehouse.carriers[0]);
  }, [warehouse.id]);

  const submit = async (e) => {
    e.preventDefault();
    const count = parseInt(packages, 10);
    if (!count || count < 1) return;
    setSaving(true);
    try {
      await onAdd({ carrier, packages: count, time, notes });
      setPackages("");
      setNotes("");
      setTime(nowTime());
    } finally {
      setSaving(false);
    }
  };

  return (
    <form
      onSubmit={submit}
      className="bg-white border border-slate-200 rounded-md shadow-sm p-4"
      data-testid="delivery-form"
    >
      <div className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500 mb-3">
        Log a delivery — {warehouse.name}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-12 gap-3">
        <div className="md:col-span-3">
          <Select value={carrier} onValueChange={setCarrier} disabled={disabled}>
            <SelectTrigger data-testid="carrier-select" className="bg-white">
              <SelectValue placeholder="Carrier" />
            </SelectTrigger>
            <SelectContent>
              {warehouse.carriers.map((c) => (
                <SelectItem key={c} value={c} data-testid={`carrier-option-${c.replace(/\s+/g, "-").toLowerCase()}`}>
                  {c}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div className="md:col-span-2">
          <Input
            data-testid="packages-input"
            type="text"
            inputMode="numeric"
            placeholder="# Packages"
            value={packages}
            onChange={(e) => setPackages(e.target.value)}
            disabled={disabled}
            required
          />
        </div>
        <div className="md:col-span-2">
          <Input
            data-testid="time-input"
            type="time"
            value={time}
            onChange={(e) => setTime(e.target.value)}
            disabled={disabled}
            required
          />
        </div>
        <div className="md:col-span-3">
          <Input
            data-testid="notes-input"
            type="text"
            placeholder="Notes (optional)"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            disabled={disabled}
          />
        </div>
        <div className="md:col-span-2">
          <Button
            data-testid="add-delivery-btn"
            type="submit"
            disabled={disabled || saving}
            className="w-full bg-orange-500 hover:bg-orange-600 text-white font-semibold"
          >
            <PlusCircle size={18} weight="bold" className="mr-2" />
            {saving ? "Adding..." : "Add Entry"}
          </Button>
        </div>
      </div>
    </form>
  );
}
